<template>
    <div id="app">
        <div id="results-container" class="container justify-content-md-center">
            <div class="card mb-3" v-for="(result, index) in results" v-bind:key="index">
                <div class="card-body">
                    <router-link class="p-2 text-black" :to="`/boxscore/${result.GameID}`">Box Score</router-link>
                    <h5 class="card-title">{{result.Title}}</h5>
                    <table class="table">
                        <thead>
                            <tr>
                                <th scope="col">Team</th>
                                <th scope="col">1</th>
                                <th scope="col">2</th>
                                <th scope="col">3</th>
                                <th scope="col">4</th>
                                <th scope="col">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td scope="row">Pilgrims</td>
                                <td>{{result.BoxScore.FirstQuarter.Pilgrims}}</td>
                                <td>{{result.BoxScore.SecondQuarter.Pilgrims}}</td>
                                <td>{{result.BoxScore.ThirdQuarter.Pilgrims}}</td>
                                <td>{{result.BoxScore.FourthQuarter.Pilgrims}}</td>
                                <td>{{result.PilgrimsScore}}</td>
                            </tr>
                            <tr>
                                <td>Indians</td>
                                <td>{{result.BoxScore.FirstQuarter.Indians}}</td>
                                <td>{{result.BoxScore.SecondQuarter.Indians}}</td>
                                <td>{{result.BoxScore.ThirdQuarter.Indians}}</td>
                                <td>{{result.BoxScore.FourthQuarter.Indians}}</td>
                                <td>{{result.IndiansScore}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Results',
    data() {
        return {
            results: {}
        }
    },
    methods: {
        fetchResults() {
            fetch('https://buhbq6w0mb.execute-api.us-east-2.amazonaws.com/Production/results', {
                method: 'GET'
            })
              .then(response => response.json())
              .then(json => this.results = json.Items)
        }
    },
    created() {
        this.fetchResults();
    }
}
</script>




// WEBPACK FOOTER //
// src/components/Results.vue